export enum ModuleName {
  Scripts = 'scripts',
  Emails = 'emails',
  DNC = 'dnc',
  TPR = 'tpr',
  CallRecording = 'call-recording',
  VoiceProvider = 'voice-provider',
  DialerSubAccount = 'dialer-sub-account',
}
